import { useState, useEffect, useRef } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';

export default function AIContextMenu({ 
  position, 
  onClose, 
  onSelect, 
  selectedText,
  isLoading = false 
}) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const aiOptions = [
    { id: 'rewrite', label: 'Rewrite', description: 'Rewrite while keeping meaning' },
    { id: 'improve', label: 'Improve', description: 'Make it more compelling' },
    { id: 'shorten', label: 'Shorten', description: 'Make it more concise' },
    { id: 'expand', label: 'Expand', description: 'Add more detail' },
    { id: 'tone', label: 'Change Tone', description: 'Professional, Casual, etc.' },
  ];

  if (!position) return null;

  return (
    <div
      ref={menuRef}
      className="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 min-w-[200px]"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    >
      <div className="p-2 border-b border-gray-200 bg-blue-50">
        <div className="flex items-center gap-2 text-xs font-semibold text-blue-700">
          <Sparkles size={14} />
          <span>AI Enhance</span>
        </div>
      </div>
      <div className="py-1">
        {aiOptions.map((option) => (
          <button
            key={option.id}
            onClick={() => onSelect(option.id)}
            disabled={isLoading}
            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-between"
          >
            <div>
              <div className="font-medium text-gray-700">{option.label}</div>
              <div className="text-xs text-gray-500">{option.description}</div>
            </div>
            {isLoading && option.id === 'loading' && (
              <Loader2 size={14} className="animate-spin text-blue-600" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

